import React from "react";
import {connect} from "react-redux";
import List from '../../../components/CRM/List';
import {Datagrid, TextField, BooleanField} from "admin-on-rest";
import Avatar from "material-ui/Avatar";
import {listStyle} from "./style";
import ActionBar from "../../../components/CRM/ActionBar/";
import ActionMenu from "../../../components/CRM/ActionMenu";
import PartnerFilter from "./PartnerFilter";
import {refreshView as refreshViewAction} from "admin-on-rest";

class FullNameFieldBase extends React.Component {
  render() {
    const props = {...this.props};
    const record = {...props.record};
    const avatar = props.avatar;

    return (
      <div style={listStyle.textFieldContainer}>
        <Avatar src={avatar} style={{minWidth: 40}} />
        <span style={listStyle.textFieldStyle}>
          {record.first_name} {record.last_name}
        </span>
      </div>
    );
  }
}

const mapStateToProps2 = (state) => {
  return {
    avatar: state.images.avatar_logo
  };
};

const FullNameField = connect(mapStateToProps2)(FullNameFieldBase);

const AdressField = ({record = {}}) => (
  <div style={listStyle.textFieldContainer}>
    <span style={listStyle.textFieldStyle}>
      {record.city}
      {", "}
      {record.post_number}
    </span>
  </div>
);

class PartnerDataListBase extends React.Component {
  state = {
    selectedRow: [],
    selectedAll: "",
    selectedIds: []
  };

  handleRowSelection = value => {
    if (Array.isArray(value)) {
      this.props.record.selectedRow = value;
    } else {
      this.props.record.selectedAll = value;
    }
    this.handleIdsSelection();
  };

  handleIdsSelection = () => {
    if (this.props.record.selectedAll === "none") {
      this.handleUnselectAll();
    } else {
      if (this.props.record.selectedAll === "all") {
        this.handleSelectAll();
      } else {
        if (
          this.props.record.selectedRow[0] ||
          this.props.record.selectedRow[0] === 0
        ) {
          this.handleSelectIds();
        } else {
          this.handleUnselectIds();
        }
      }
    }
  };

  handleUnselectAll = () => {
    this.props.record.ids = [];
    this.props.record.selectedAll = "";
    this.props.record.selectedRow = "";
    this.handleResetState();
    this.props.refreshView();
  };

  handleSelectAll = () => {
    this.props.record.ids = this.props.record.list.ids;
    this.props.record.selectedRow = [];
    this.props.record.selectedAll = "";
    this.handleResetState();
  };

  handleSelectIds = () => {
    this.props.record.list.ids.forEach((pair, index) => {
      this.props.record.selectedRow.forEach((value, key) => {
        if (value === index) {
          this.handleAddId(pair);
        }
        this.state.selectedIds.forEach((id, nb) => {
          if (id === pair) {
            if (!this.props.record.selectedRow.includes(index)) {
              this.handleRemoveId(id);
            }
          }
        });
      });
    });
  };

  handleAddId = pair => {
    if (this.state.selectedIds && !this.state.selectedIds.includes(pair)) {
      this.state.selectedIds.push(pair);
      this.props.record.ids = this.state.selectedIds;
    }
  };

  handleRemoveId = id => {
    function remove(array, element) {
      const index = array.indexOf(element);

      if (index !== -1) {
        array.splice(index, 1);
      }
    }
    remove(this.state.selectedIds, id);
    this.props.record.ids = this.state.selectedIds;
  };

  handleUnselectIds = () => {
    this.props.record.ids = [];
    this.props.record.selectedRow = [];
    this.handleResetState();
    this.props.refreshView();
  };

  handleResetState = () => {
    this.setState({
      selectedIds: [],
      selectedAll: "",
      selectedRow: []
    });
  };

  render() {
    const props = {...this.props};

    props.record.list.ids.forEach((pair, index) => {
      const slipId = pair;
      if (slipId && props.record.data[slipId] !== null) {
        props.record.data[slipId].full_name =
          props.record.data[slipId].first_name +
          " " +
          props.record.data[slipId].last_name;
      }
    });
    return (
      <List
        title="resources.storeOwners.name"
        {...props}
        actions={<ActionBar {...props} />}
        sort={{field: "first_name", order: "ASC"}}
        filters={<PartnerFilter />}
      >
        <Datagrid
          options={{
            multiSelectable: true,
            selectable: true,
            onRowSelection: this.handleRowSelection
          }}
          headerOptions={{
            adjustForCheckbox: true,
            displaySelectAll: true,
            enableSelectAll: true
          }}
          bodyOptions={{
            displayRowCheckbox: true,
            deselectOnClickaway: false,
            showRowHover: true
          }}
          rowOptions={{
            selectable: true
          }}
        >
          <FullNameField
            label="resources.storeOwners.fields.storeOwner"
            source="first_name,last_name"
            record={props.record}
          />
          <TextField
            label="resources.storeOwners.fields.email"
            source="email"
          />

          <TextField
            label="resources.storeOwners.fields.companyName"
            source="company_name"
          />
          <AdressField
            label="resources.storeOwners.fields.companyAddress"
            source="city"
          />

          <BooleanField
            elStyle={listStyle.booleanFieldStyle}
            label="resources.storeOwners.fields.active"
            source="active"
          />
          <ActionMenu />
        </Datagrid>
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    record: state.admin.resources[props.resource]
  };
};

const PartnerDataList = connect(
  mapStateToProps,
  {
    refreshView: refreshViewAction
  }
)(PartnerDataListBase);

export default PartnerDataList;



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/PartnerDataList.js